import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { MODULE_ROUTE } from "../../routers/module-router";
import { IRootState } from "../../store";
import { toggleSidebar, toggleTheme } from "../../store/themeConfigSlice";
import CookieUtils from "../../utils/cookie-utils";
import Dropdown from "../custom/drop-down";
import ImageCustom from "../custom/image-custom";
import IconBellBing from "../icons/icon-bell-bing";
import IconLaptop from "../icons/icon-laptop";
import IconLogout from "../icons/icon-logout";
import IconMenu from "../icons/icon-menu";
import IconMoon from "../icons/icon-moon";
import IconSun from "../icons/icon-sun";
import IconUser from "../icons/icon-user";
import IconX from "../icons/icon-x";

export const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isRtl = useSelector((state: IRootState) => state.themeConfig.rtlClass) === "rtl";

  const [notifications, setNotifications] = useState([
    {
      id: 1,
      profile: "user-profile.jpeg",
      message: '<strong className="mr-1 text-sm">John Doe</strong>invite you to <strong>Prototyping</strong>',
      time: "45 min ago",
    },
    {
      id: 2,
      profile: "profile-34.jpeg",
      message: '<strong className="mr-1 text-sm">Adam Nolan</strong>mentioned you to <strong>UX Basics</strong>',
      time: "9h Ago",
    },
    {
      id: 3,
      profile: "profile-16.jpeg",
      message: '<strong className="mr-1 text-sm">Anna Morgan</strong>Upload a file',
      time: "9h Ago",
    },
  ]);

  const themeConfig = useSelector((state: IRootState) => state.themeConfig);

  return (
    <header className={`z-40 navbar${themeConfig.semidark && themeConfig.menu === "horizontal" ? "dark" : ""}`}>
      <div className="shadow-sm">
        <div className="relative bg-white flex w-full items-center px-5 py-2.5 dark:bg-black">
          <div className="flex items-center justify-between horizontal-logo lg:hidden ltr:mr-2 rtl:ml-2">
            <Link to="/" className="flex items-center main-logo shrink-0">
              <ImageCustom className="inline w-8 ltr:-ml-1 rtl:-mr-1" />
              <span className="text-2xl ltr:ml-1.5 rtl:mr-1.5  font-semibold  align-middle hidden md:inline dark:text-white-light transition-all duration-300">
                SCYBER
              </span>
            </Link>
            <button
              type="button"
              className="collapse-icon flex-none dark:text-[#d0d2d6] hover:text-primary dark:hover:text-primary flex lg:hidden ltr:ml-2 rtl:mr-2 p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:bg-white-light/90 dark:hover:bg-dark/60"
              onClick={() => {
                dispatch(toggleSidebar());
              }}
            >
              <IconMenu className="w-5 h-5" />
            </button>
          </div>

          <div className="sm:flex-1 ltr:sm:ml-0 ltr:ml-auto sm:rtl:mr-0 rtl:mr-auto flex items-center space-x-1.5 lg:space-x-2 rtl:space-x-reverse dark:text-[#d0d2d6]">
            <p className="flex-1 font-extrabold text-orange-600 uppercase">{themeConfig.menuContent}</p>

            <div>
              {themeConfig.theme === "light" ? (
                <button
                  className={`${
                    themeConfig.theme === "light" &&
                    "flex items-center p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60"
                  }`}
                  onClick={() => {
                    dispatch(toggleTheme("dark"));
                  }}
                >
                  <IconSun />
                </button>
              ) : (
                ""
              )}
              {themeConfig.theme === "dark" && (
                <button
                  className={`${
                    themeConfig.theme === "dark" &&
                    "flex items-center p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60"
                  }`}
                  onClick={() => {
                    dispatch(toggleTheme("system"));
                  }}
                >
                  <IconMoon />
                </button>
              )}
              {themeConfig.theme === "system" && (
                <button
                  className={`${
                    themeConfig.theme === "system" &&
                    "flex items-center p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60"
                  }`}
                  onClick={() => {
                    dispatch(toggleTheme("light"));
                  }}
                >
                  <IconLaptop />
                </button>
              )}
            </div>

            <div className="dropdown shrink-0">
              <Dropdown
                offset={[0, 8]}
                placement={`${isRtl ? "bottom-start" : "bottom-end"}`}
                btnClassName="relative block p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60"
                button={
                  <span>
                    <IconBellBing />
                    <span className="absolute top-0 flex w-3 h-3 ltr:right-0 rtl:left-0">
                      <span className="animate-ping absolute ltr:-left-[3px] rtl:-right-[3px] -top-[3px] inline-flex h-full w-full rounded-full bg-success/50 opacity-75"></span>
                      <span className="relative inline-flex rounded-full w-[6px] h-[6px] bg-success"></span>
                    </span>
                  </span>
                }
              >
                <ul className="!py-0 text-dark dark:text-white-dark w-[300px] sm:w-[350px] divide-y dark:divide-white/10">
                  <li onClick={(e) => e.stopPropagation()}>
                    <div className="flex items-center justify-between px-4 py-2 font-semibold">
                      <h4 className="text-lg">Thông báo</h4>
                      {notifications.length ? (
                        <span className="badge bg-primary/80">{notifications.length}Mới</span>
                      ) : (
                        ""
                      )}
                    </div>
                  </li>
                  {notifications.length > 0 ? (
                    <>
                      {notifications.map((notification) => {
                        return (
                          <li
                            key={notification.id}
                            className="dark:text-white-light/90"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="flex items-center px-4 py-2 group">
                              <div className="grid rounded place-content-center">
                                <div className="relative w-12 h-12">
                                  <img
                                    className="object-cover w-12 h-12 rounded-full"
                                    alt="profile"
                                    src={`/assets/images/${notification.profile}`}
                                  />
                                  <span className="bg-success w-2 h-2 rounded-full block absolute right-[6px] bottom-0"></span>
                                </div>
                              </div>
                              <div className="flex flex-auto ltr:pl-3 rtl:pr-3">
                                <div className="ltr:pr-3 rtl:pl-3">
                                  <h6
                                    dangerouslySetInnerHTML={{
                                      __html: notification.message,
                                    }}
                                  ></h6>
                                  <span className="block text-xs font-normal dark:text-gray-500">
                                    {notification.time}
                                  </span>
                                </div>
                                <button
                                  type="button"
                                  className="opacity-0 ltr:ml-auto rtl:mr-auto text-neutral-300 hover:text-danger group-hover:opacity-100"
                                >
                                  <IconX />
                                </button>
                              </div>
                            </div>
                          </li>
                        );
                      })}
                      <li>
                        <div className="p-4">
                          <button className="block w-full btn btn-primary btn-small">Read All Notifications</button>
                        </div>
                      </li>
                    </>
                  ) : (
                    <li onClick={(e) => e.stopPropagation()}>
                      <button
                        type="button"
                        className="!grid place-content-center hover:!bg-transparent text-lg min-h-[200px]"
                      >
                        <div className="mx-auto mb-4 rounded-full ring-4 ring-primary/30 text-primary">
                          <IconX fill={true} className="w-10 h-10" />
                        </div>
                        No data available.
                      </button>
                    </li>
                  )}
                </ul>
              </Dropdown>
            </div>
            <div className="flex dropdown shrink-0">
              <Dropdown
                offset={[0, 8]}
                placement={`${isRtl ? "bottom-start" : "bottom-end"}`}
                btnClassName="relative group block"
                button={
                  <ImageCustom
                    className="object-cover rounded-full w-9 h-9 saturate-50 group-hover:saturate-100 border border-[#f2f2f2]"
                    isLocal={false}
                    url={CookieUtils.getCurrentUser().avatar ?? ""}
                  />
                }
              >
                <ul className="text-dark dark:text-white-dark !py-0 w-[230px] font-semibold dark:text-white-light/90">
                  <li>
                    <div className="flex items-center px-4 py-4">
                      <ImageCustom
                        className="object-cover w-10 h-10 rounded-md border border-[#f2f2f2]"
                        isLocal={false}
                        url={CookieUtils.getCurrentUser().avatar ?? ""}
                      />
                      <div className="truncate ltr:pl-4 rtl:pr-4">
                        <h4 className="text-base">
                          {CookieUtils.getCurrentUser().name ?? ""}
                          <span className="px-1 text-xs rounded bg-success-light text-success ltr:ml-2 rtl:ml-2">
                            Pro
                          </span>
                        </h4>
                      </div>
                    </div>
                  </li>
                  <li>
                    <Link to={MODULE_ROUTE.PROFILE} className="dark:hover:text-white">
                      <IconUser className="w-4.5 h-4.5 ltr:mr-2 rtl:ml-2 shrink-0" />
                      Tài khoản của tôi
                    </Link>
                  </li>
                  <li className="border-t border-white-light dark:border-white-light/10">
                    <a
                      href="/#"
                      onClick={(e) => {
                        e.preventDefault();
                        CookieUtils.eraseCookie("user");
                        CookieUtils.eraseCookie("domain");
                        window.location.href = MODULE_ROUTE.LOGIN;
                      }}
                      className="text-danger !py-3"
                    >
                      <IconLogout className="w-4.5 h-4.5 ltr:mr-2 rtl:ml-2 rotate-90 shrink-0" />
                      Đăng xuất
                    </a>
                  </li>
                </ul>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
